import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  paymentAmountInfo: {
    defaultMessage: "By authenticating, you'll make a payment of {amount} to {recipient}",
    id: 'PaymentInfoContainer.paymentAmountInfo',
  },
  totalPayment: {
    defaultMessage: 'Total',
    id: 'PaymentInfoContainer.totalPayment',
  },
  payingTo: {
    defaultMessage: 'Paying to',
    id: 'PaymentInfoContainer.payingTo',
  },
  payingFrom: {
    defaultMessage: 'Paying from',
    id: 'PaymentInfoContainer.payingFrom',
  },
  executionDate: {
    defaultMessage: 'Execution date',
    id: 'PaymentInfoContainer.executionDate',
  },
  firstPaymentDate: {
    defaultMessage: 'First payment date',
    id: 'firstPaymentDate',
  },
  repeats: {
    defaultMessage: 'Repeats',
    id: 'repeats',
  },
  every: {
    defaultMessage: 'Every',
    id: 'Every',
  },
  monday: {
    defaultMessage: 'Monday',
    id: 'Monday',
  },
  tuesday: {
    defaultMessage: 'Tuesday',
    id: 'Tuesday',
  },
  wednesday: {
    defaultMessage: 'Wednesday',
    id: 'Wednesday',
  },
  thursday: {
    defaultMessage: 'Thursday',
    id: 'Thursday',
  },
  friday: {
    defaultMessage: 'Friday',
    id: 'Friday',
  },
  saturday: {
    defaultMessage: 'Saturday',
    id: 'Saturday',
  },
  sunday: {
    defaultMessage: 'Sunday',
    id: 'Sunday',
  },
  monthly: {
    defaultMessage: 'Monthly',
    id: 'Monthly',
  },
});
